// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"214":"polyfills-core-js","748":"polyfills-dom"}[chunkId] || chunkId) + "." + {"28":"7726033d","214":"2941dcd2","306":"e7c1c99d","421":"a9075c35","490":"2fe313fa","569":"ec3c3ad3","615":"07550fdb","644":"7bd9ed9e","710":"db8b4e1c","748":"d574dae0","949":"de55b015","968":"861cee60"}[chunkId] + ".chunk.js";
};